import {SetSelected} from "../tableHandler/manipulateTable";
import {GetSelectedFeatureIdsOfMap, GetSelectedFeaturesOfMap} from "../function/functions";

export function FeatureListenerCallback(callback, getRowCallback, pageName) {
    const conditionFunction = typeof callback == "function";
    const conditionFunctionGetRowCallback = typeof getRowCallback == "function";
    let ids = [];
    window.addEventListener('storage', function (e) {
        if (e.key !== 'selectedFeatures'){
            return;
        }
        const features = GetSelectedFeaturesOfMap();
        if(pageName !== [...window.location.href.split('/')].at(-1)){
            return
        }
        ids = GetSelectedFeatureIdsOfMap();
        if (conditionFunction) {
            callback(features);
        } else {
            if (conditionFunctionGetRowCallback){
                getRowCallback(SetSelected(ids));
            }else {
                SetSelected(ids);
            }
        }
    });
    // Return it to use as a callback
    if(!conditionFunction){
        return () => SetSelected(ids)
    } else {
        return () => callback(ids)
    }
}


export function FilterFeaturesSelectedOnMap(allItems){

    const features = JSON.parse(localStorage.getItem("selectedFeatures"));

    return allItems.data.filter((el) => {
        return features.some((f) => {
            return f.properties.identification === el.identification;
        });
    })
}